
import Card from '../../../components/base/Card';

export default function CourseOverview() {
  const courseModules = [
    {
      id: 1,
      title: '会计基础团队',
      description: '掌握会计基础理论，学习税务会计、管理会计、行政事业单位会计等核心课程',
      icon: 'ri-calculator-line',
      color: 'bg-blue-500',
      courses: ['税务会计', '管理会计', '行政事业单位会计', '企业财务管理', '财务审计'],
      image: 'https://public.readdy.ai/ai/img_res/3f4c095e684eee0144386c198889578c.jpg'
    },
    {
      id: 2,
      title: '税务专业小组',
      description: '深入学习税法理论与实务，掌握纳税筹划、申报、检查等专业技能',
      icon: 'ri-file-text-line',
      color: 'bg-green-500',
      courses: ['纳税筹划合规', '纳税检查', '纳税申报实训', '税收征管流程实训', '智慧化税费申报与管理'],
      image: 'https://readdy.ai/api/search-image?query=Tax%20professional%20workspace%20with%20legal%20documents%2C%20tax%20forms%2C%20digital%20tablets%20showing%20tax%20software%2C%20modern%20office%20with%20green%20accents%2C%20organized%20filing%20system%2C%20professional%20tax%20consultation%20setup&width=400&height=300&seq=course2&orientation=landscape'
    },
    {
      id: 3,
      title: '财务管理小组',
      description: '学习企业财务管理理论与实践，掌握内部控制与风险管理技能',
      icon: 'ri-line-chart-line',
      color: 'bg-purple-500',
      courses: ['管理会计', '企业内部控制与风险管理', '财务审计'],
      image: 'https://readdy.ai/api/search-image?query=Financial%20management%20office%20with%20charts%2C%20graphs%2C%20risk%20assessment%20documents%2C%20modern%20workspace%20with%20purple%20accents%2C%20financial%20planning%20tools%2C%20strategic%20analysis%20setup&width=400&height=300&seq=course3&orientation=landscape'
    },
    {
      id: 4,
      title: '数字化技能群',
      description: '掌握大数据技术在财务中的应用，提升数字化分析能力',
      icon: 'ri-database-2-line',
      color: 'bg-teal-500',
      courses: ['Excel在财务中的应用', '财税大数据分析'],
      image: 'https://readdy.ai/api/search-image?query=Digital%20finance%20workspace%20with%20multiple%20monitors%20showing%20data%20analytics%2C%20Excel%20spreadsheets%2C%20big%20data%20visualizations%2C%20modern%20tech%20office%20with%20teal%20color%20scheme%2C%20data%20analysis%20tools&width=400&height=300&seq=course4&orientation=landscape'
    },
    {
      id: 5,
      title: '智能财税群体',
      description: '学习智能财税系统应用，掌握财税机器人开发与维护技能',
      icon: 'ri-robot-line',
      color: 'bg-orange-500',
      courses: ['财税机器人开发与维护', '税务管理', '业财管理信息系统应用'],
      image: 'https://readdy.ai/api/search-image?query=AI%20finance%20technology%20workspace%20with%20robotic%20automation%20systems%2C%20intelligent%20tax%20software%20interfaces%2C%20modern%20tech%20environment%20with%20orange%20accents%2C%20automated%20financial%20processes&width=400&height=300&seq=course5&orientation=landscape'
    },
    {
      id: 6,
      title: '劳动教育群体',
      description: '培养新时代大学生劳动观念，提升劳动技能与社会责任感',
      icon: 'ri-team-line',
      color: 'bg-red-500',
      courses: ['劳动观念', '劳动技能'],
      image: 'https://readdy.ai/api/search-image?query=Educational%20workshop%20environment%20with%20students%20collaborating%2C%20teamwork%20activities%2C%20skill%20development%20training%2C%20modern%20classroom%20with%20red%20accents%2C%20practical%20learning%20setup&width=400&height=300&seq=course6&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            六大核心模块
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            系统化的课程体系设计，从基础理论到实践应用，全面覆盖财税大数据专业核心知识点
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {courseModules.map((module) => (
            <Card key={module.id} hover className="h-full">
              <div className="relative">
                <img 
                  src={module.image} 
                  alt={module.title}
                  className="w-full h-48 object-cover object-top rounded-lg mb-4"
                />
                <div className={`absolute top-4 left-4 w-12 h-12 ${module.color} rounded-lg flex items-center justify-center`}>
                  <i className={`${module.icon} text-white text-xl`}></i>
                </div>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">{module.title}</h3>
              <p className="text-gray-600 mb-4 text-sm leading-relaxed">{module.description}</p>
              
              <div className="space-y-2">
                <h4 className="font-semibold text-gray-800 text-sm">核心课程：</h4>
                <div className="flex flex-wrap gap-2">
                  {module.courses.map((course, index) => (
                    <span 
                      key={index}
                      className="px-2 py-1 bg-gray-100 text-gray-700 rounded-md text-xs"
                    >
                      {course}
                    </span>
                  ))}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
